import React from 'react';
import AtlaskitCalendar from '@atlaskit/calendar';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

export interface CalendarProps {
  minDate: string;
  maxDate: string;
  selectedDate: string | null;
  onSelect: (value: { iso: string; day: number; month: number; year: number }) => void;
  disabledDateFilter?: (date: string) => boolean;
}

export const Calendar: React.FC<CalendarProps> = ({ minDate, maxDate, selectedDate, onSelect, disabledDateFilter }) => {
  return (
    <AtlaskitCalendar
      minDate={minDate}
      maxDate={maxDate}
      onSelect={onSelect}
      selected={selectedDate ? [selectedDate] : []}
      disabledDateFilter={disabledDateFilter}
      css={calendarStyles}
      testId="custom-calendar"
    />
  );
};

const calendarStyles = css({
  textAlign: 'center',

  '& h2': {
    color: token('color.text'),
    textAlign: 'center',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Charlie Display',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },

  // main container
  '& > div': {
    width: '100%',
    maxWidth: '600px',
  },

  // top row
  '& > div > div > div:first-of-type': {
    [media.below.md]: {
      paddingLeft: token('space.400'),
      paddingRight: token('space.400'),
    },

    // previous month button
    '& > div > div:first-of-type button:first-of-type': {
      display: 'none',
    },

    // next month button
    '& > div > div:last-of-type button:last-of-type': {
      display: 'none',
    },
  },

  // weekday headings (Mon, Tue, Wed, etc.)
  '& [data-testid="custom-calendar--column-headers"]': {
    color: token('color.text.subtle'),
    textAlign: 'center',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: 'Charlie Text',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
    textTransform: 'uppercase',
  },

  // weekday cells
  '& [data-testid="custom-calendar--day-cell"]': {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },

  '& [data-testid="custom-calendar--day"]:not([data-disabled="true"])': {
    color: token('color.text'),
  },
});
